import { Dayjs } from 'dayjs';
import { V2EnergyConsumptionPlanGasSupplySchedulePostResponse } from '@maxtropy/device-customer-apis-v2';

export type SearchFormValues = {
  selectedDate?: Dayjs;
  areaIds?: number[];
  valveIds?: number[];
  stationRooms?: number[];
};

export enum ValveStatus {
  Open = 1,
  Close = 2,
  Offline = 3,
}

export type RecordType = 'manual' | 'automatic';

export interface SwitchRecordItem {
  id: number;
  operatedAt: string;
  type: RecordType;
  beforeStatus: Exclude<ValveStatus, ValveStatus.Offline>;
  afterStatus: Exclude<ValveStatus, ValveStatus.Offline>;
  operator: string;
}

export type GasScheduleApiRow = Exclude<
  V2EnergyConsumptionPlanGasSupplySchedulePostResponse['list'],
  undefined
>[number];
